export default __webpack_public_path__ + "static/media/arctic.65528e6f.jpg";